export class EventRegistrationData {
  public email: string;
  public firstname: string;
  public lastname: string;
  public joinUrl: string;
  public metadata?: { [key: string]: string };
}
